import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { ThemeContext } from '@cred/react-theme'

import CtaButton from 'components/cta-button'

const RateTableCtaButton = ({
  containerClassName = '',
  btnText = 'Find My Rate',
  disclaimerText = "on Credible's website",
  disclaimerClassName = '',
  vertical,
  transparent: propTransparent,
  ...props
}) => {
  const theme = useContext(ThemeContext)
  const isFoxmoneyTheme = theme === 'foxmoney'

  const transparent = isFoxmoneyTheme && vertical !== 'student-loan' ? false : propTransparent
  const variant = transparent ? 'outlined' : 'contained'

  return (
    <div className={containerClassName}>
      <CtaButton {...props} size="small" variant={variant}>
        {btnText}
      </CtaButton>
      <p className={cx(disclaimerClassName, 'mt-8 disclaimer neutral500')}>{disclaimerText}</p>
    </div>
  )
}

RateTableCtaButton.propTypes = {
  disclaimerClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  btnText: PropTypes.string,
  transparent: PropTypes.bool,
  disclaimerText: PropTypes.string,
  vertical: PropTypes.string,
}

export default RateTableCtaButton
